<template>
  <el-card>
    <el-form label-position="left" label-width="auto">
      <el-form-item :label="$t('动态编号')">
        <el-input :placeholder="$t('动态编号')" disabled :value="detailInfo.num"/>
      </el-form-item>

      <el-form-item :label="$t('动态内容')">
        <el-input :placeholder="$t('动态内容')" :value="detailInfo.content"/>
      </el-form-item>

      <el-form-item :label="$t('动态图片')">
        <div class="fb-link-flex">
          <el-image
              v-for="(pic, index) in detailInfo.photoList"
              :preview-src-list="detailInfo.photoList"
              :key="index"
              :src="pic"/>
        </div>
      </el-form-item>

      <el-form-item :label="$t('发布者编号')">
        <el-input :placeholder="$t('发布者编号')" disabled :value="detailInfo.userNum"/>
      </el-form-item>

      <el-form-item :label="$t('发布者昵称')">
        <el-input :placeholder="$t('发布者昵称')" disabled :value="detailInfo.username"/>
      </el-form-item>

      <el-form-item :label="$t('发布时间')">
        <el-input :placeholder="$t('发布时间')" disabled :value="detailInfo.createTimeStr"/>
      </el-form-item>

      <el-form-item :label="$t('点赞数')">
        <el-input :placeholder="$t('点赞数')" disabled :value="detailInfo.baseLike"/>
      </el-form-item>
      <el-form-item :label="$t('真实点赞数')">
        <el-input :placeholder="$t('点赞数')" disabled :value="detailInfo.likeCount"/>
      </el-form-item>
      <el-form-item :label="$t('讨论数')">
        <el-input :placeholder="$t('讨论数')" disabled :value="detailInfo.commentCount"/>
      </el-form-item>

      <el-form-item :label="$t('精品置顶')">
        <el-input :placeholder="$t('精品置顶')" disabled :value="detailInfo.topping"/>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import {request} from "@/config/request";

export default {
  name: "DynamicDetail",
  components: {},
  data() {
    return {
      detailInfo: {}
    }
  },
  methods: {
    async loadDetail() {
      try {
        const res = await request(this.$api.dynamics.detail, this.$route.query);
        this.detailInfo = res.dynamics;
        this.detailInfo.createTimeStr = this.$moment(res.dynamics.createTime).format("YYYY-MM-DD HH:mm:ss");
        const photoList = res.dynamics.photo ? res.dynamics.photo.split(",") : [];
        this.detailInfo.photoList = photoList.map(i => this.$api.file.downloadImg + i);
      } catch (e) {
        console.log(e);
      }
    }
  },
  created() {
    this.loadDetail();
  }
}
</script>

<style scoped>

.el-form {
  max-width: 700px;
}

</style>
